module.exports = __webpack_public_path__ + "static/img/img_0724.ddc727e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/img_0724.jpg
// module id = 53qN
// module chunks = 0